import styles from "./OtpInputItem.module.scss";
import { InputProps as OriginalInputProps } from "react-otp-input";

interface InputProps extends OriginalInputProps {
  disabled?: boolean;
}
import React, { forwardRef } from "react";

export const OtpInputItem = forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    return <input {...props} ref={ref} className={styles.otpInputItem} />;
  },
);

OtpInputItem.displayName = "OtpInputItem";
